import { useCallback, useMemo } from 'react';
import { gatewayV2 } from '../../../helpers/client';
import { FORM_FIELDS } from '../../../constants';
import { useFormData, useIsOffersShownOnce } from '../../../store/selectors/formStore';
import { useIsPage } from '../../../store/selectors/selection';

const PRE_APPROVAL_SEARCH_TRIGGER_FIELDS = [
    FORM_FIELDS.AMOUNT,
    FORM_FIELDS.PERIOD,
    FORM_FIELDS.PURPOSE,
    FORM_FIELDS.REGION_LOCATION_ROUTE,
    FORM_FIELDS.BIRTH_PLACE,
    FORM_FIELDS.EMAIL,
    FORM_FIELDS.PHONE,
    FORM_FIELDS.FIRST_NAME,
    FORM_FIELDS.LAST_NAME,
    FORM_FIELDS.MIDDLE_NAME,
    FORM_FIELDS.GENDER,
    FORM_FIELDS.BIRTHDAY,
    FORM_FIELDS.PASSPORT_NUMBER,
    FORM_FIELDS.ISSUED,
    FORM_FIELDS.PASSPORT_DATE,
    FORM_FIELDS.UNIT_CODE,
    FORM_FIELDS.REGISTRATION_STREET,
    FORM_FIELDS.RESIDENCE_STREET,
    FORM_FIELDS.REGISTRATION_APARTMENT,
    FORM_FIELDS.RESIDENCE_APARTMENT,
] as const;

const PRE_APPROVAL_SEARCH_REQUIRED_FIELDS = [
    FORM_FIELDS.AMOUNT,
    FORM_FIELDS.PERIOD,
    FORM_FIELDS.PURPOSE,
    FORM_FIELDS.BIRTH_PLACE,
    FORM_FIELDS.EMAIL,
    FORM_FIELDS.PHONE,
    FORM_FIELDS.FIRST_NAME,
    FORM_FIELDS.LAST_NAME,
    FORM_FIELDS.GENDER,
    FORM_FIELDS.BIRTHDAY,
    FORM_FIELDS.PASSPORT_NUMBER,
    FORM_FIELDS.REGISTRATION_STREET,
    FORM_FIELDS.RESIDENCE_STREET,
] as const;

export const useIsPreApprovalSearchAvailablePage = () => {
    const { isMainPage, isCardsFormPage } = useIsPage();
    return isMainPage || isCardsFormPage;
};

export const usePreApprovalSearch = (enabled = true) => {
    const formData = useFormData();
    const isOffersShownOnce = useIsOffersShownOnce();
    const isAvailablePage = useIsPreApprovalSearchAvailablePage();
    const hasAllRequiredFields = useMemo(
        () =>
            PRE_APPROVAL_SEARCH_REQUIRED_FIELDS.every((field) => {
                const value = formData[field];
                return value !== undefined && value !== null && value !== '';
            }),
        [formData],
    );

    return useCallback(
        async (updatedFields: Array<keyof FE.FormData>) => {
            if (!enabled || !isAvailablePage) {
                return false;
            }

            if (!hasAllRequiredFields) {
                return false;
            }

            const hasTriggerField = PRE_APPROVAL_SEARCH_TRIGGER_FIELDS.some((field) => updatedFields.includes(field));
            if (!hasTriggerField) {
                return false;
            }
            await gatewayV2.preApprovalsSearch({ isFullProfile: isOffersShownOnce });
            return true;
        },
        [hasAllRequiredFields, enabled, isAvailablePage, isOffersShownOnce],
    );
};
